import { render, staticRenderFns } from "./SwitchesInset.vue?vue&type=template&id=6009173a&"
import script from "./SwitchesInset.vue?vue&type=script&lang=js&"
export * from "./SwitchesInset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports